import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Box, Typography } from "@mui/material";
import SnRadioBox from "@shared/components/SnRadioBox";

const ExcelDialog = forwardRef((_, ref) => {
  const [selectedOption, setSelectedOption] = useState<string>("download"); // 기본값: 다운로드

  useImperativeHandle(ref, () => ({
    getSelectedValue: () => selectedOption,
  }));

  return (
    <Box
      sx={{
        width: "300px",
        padding: "10px",
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <SnRadioBox
        defaultValue={selectedOption}
        sql={
          "select 'download' as code, '양식 DownLoad' as name union all select 'upload' as code, 'Upload' as name"
        }
        onValueChanged={setSelectedOption}
        emptyLine={false}
      />
    </Box>
  );
});

export default ExcelDialog;
